import React, {useEffect, useState} from "react";
import { RadarChart, PolarGrid, PolarAngleAxis, PolarRadiusAxis, ResponsiveContainer , Customized } from "recharts";
import { useParams } from "react-router-dom";
import {LoaderMedium} from './../../components/loader';
import {post_api_call, error_api_call} from '../../actions/action-creators/common';
import {alertResponseMessage} from '../../actions/action-creators/response';
const traitTypes = {
    3: { trait_type: "Academic Excellence", score_perc: 0, prev_score: 0, current_score: 0, skill_data: [], color: '#ffaa0e'},
    4: { trait_type: "Leadership & Responsibility", score_perc: 0, prev_score: 0, current_score: 0, skill_data: [], color: "blue"},
    5: { trait_type: "Creativity & Innovation", score_perc: 0, prev_score: 0, current_score: 0, skill_data: [], color: "green"},
    6: { trait_type: "Extracurricular & Tech Excellence", score_perc: 0, prev_score: 0, current_score: 0, skill_data: [], color: "purple"},
    7: { trait_type: "Resilience & Work Ethic", score_perc: 0, prev_score: 0, current_score: 0, skill_data: [], color: "orange"},
    8: { trait_type: "Communication Skills", score_perc: 0, prev_score: 0, current_score: 0, skill_data: [], color:  "#eb6cb3"},
    9: { trait_type: "Career & Competitive Readiness", score_perc: 0, prev_score: 0, current_score: 0, skill_data: [], color: "#d2691e"},
    10: { trait_type: "Community & Teamwork", score_perc: 0, prev_score: 0, current_score: 0, skill_data: [], color: "#00c6c6"},
};

// const data = [
//     { subject: "Academic Excellence", value: 80, },
//     { subject: "Leadership & Responsibility", value: 90 },
//     { subject: "Creativity & Innovation", value: 70 },
//     { subject: "Extracurricular & Tech Excellence", value: 85 },
//     { subject: "Resilience & Work Ethic", value: 75 },
//     { subject: "Communication Skills", value: 60 },
//     { subject: "Career & Competitive Readiness", value: 95 },
//     { subject: "Community & Teamwork", value: 80 },
// ];
  
// const colors = ["#ffaa0e", "blue", "green", "purple", "orange", "#eb6cb3", "#d2691e", "#00c6c6"];
// const chartSize = 760;
// const centerX = chartSize / 2;
// const centerY = chartSize / 2;
// const outerRadius = 120; // Adjusted for better fit
  
function PortInsight(props){
    const { profile_id } = useParams();
    // SetMetaData("Portfolio", "", "");
    const [pageLoading, setPageLoader] = useState(true);
    const [masterTraitData, setTraitData] = useState([]);
    const [isDataAvailable, setDataAvailability] = useState(true);
    // const [prevTraitData, setPrvTraitData] = useState([]);
    // const [currentTraitData, setCurrentTraitData] = useState([]);
    // const [performanceData, setPerformData] = useState([]);
    const [hoveredData, setHoveredData] = useState(null);
    const [winWidth, setWidth]   = useState(window.innerWidth);
    const [winHeight, setHeight] = useState(window.innerHeight);
    const updateDimensions = () => {
        setWidth(window.innerWidth);
        setHeight(window.innerHeight);
    }
    //Get Personality Trait Details
    const fetchTraitData = async() => {
        try{
            const traitApiData = await post_api_call(`personality-traits`, {fetch_type: 'profile'});
            if(traitApiData.status === 200){    
                //Spider Chart Data
                var traitMapData = {...traitTypes};
                if(traitApiData.data.length){
                    traitApiData.data.forEach(master_data => {
                        //Get Score Percentage
                        const scoreEarned = master_data.total_score;
                        const totalScore = master_data.top_skills.length * 3;
                        traitMapData[master_data.category_id].score_perc = Math.round((scoreEarned * 100)/totalScore);
                        traitMapData[master_data.category_id].skill_data = master_data.top_skills;
                    });
                    console.log(traitMapData, 'traitMapData')
                }else{
                    setDataAvailability(false);
                }
                // setTraitData(Object.values(traitMapData));
                // if(traitApiData.last_month.length
                //     && traitApiData.current_month.length
                // ){
                    traitApiData.last_month.forEach(prev_data => {
                        traitMapData[prev_data.category_id].prev_score = prev_data.total_score;
                    });
                    traitApiData.current_month.forEach(current_data => {
                        traitMapData[current_data.category_id].current_score = current_data.total_score;
                    });

                    // setPerformData(Object.values(traitMapData));
                    setTraitData(Object.values(traitMapData));
                // }
                // setPrvTraitData(traitApiData.last_month);
                // setCurrentTraitData(traitApiData.current_month);
            }
            setPageLoader(false);
            props._handlePageLoader(false);
        }catch(e){
            console.log(e);
            alertResponseMessage({alert_type: 2, message: "Error Loading Details! Check back after some times"});
            error_api_call({error: `portfolio/detail|fetchTraitData|${e}`});
        }
    }
    //Intial Fetching
    useEffect(() => {
        fetchTraitData();
    }, []);// eslint-disable-line react-hooks/exhaustive-deps
    useEffect(() => {
        window.addEventListener("resize", updateDimensions);
        return () => window.removeEventListener("resize", updateDimensions);
    }, []);// eslint-disable-line react-hooks/exhaustive-deps
    // const CustomTooltip = ({ payload, label, active }) => {
    //     console.log(payload, label, active, 'llllllllllllllllllllllllll')
    //     try{
    //         if (active && payload && payload.length) {
    //             return (
    //                 <div className="custom-tooltip">
    //                 <p className="label">{`${label} : ${payload[0].value}`}</p>
    //                 <p className="intro">{getIntroOfPage(label)}</p>
    //                 <p className="desc">Anything you want can be displayed here.</p>
    //                 </div>
    //             );
    //         }
    
    //         return null;
    //     }catch(error){
    //         return null;
    //     }
    // }
    const CustomTooltip = ({ hoveredData }) => {
        console.log(hoveredData, 'hoveredDatahoveredDatahoveredData')
        if (!hoveredData || typeof hoveredData.skill_data === "undefined" || hoveredData.skill_data.length < 1) return null;
        try{
            return (
                <div
                    style={{
                        position: "absolute",
                        left: hoveredData.tooltipX-200,
                        top: hoveredData.y-370,
                        background: "white",
                        padding: "8px",
                        border: "1px solid black",
                        borderRadius: "5px",
                        boxShadow: "2px 2px 5px rgba(0,0,0,0.2)",
                        pointerEvents: "none", // Prevents tooltip from interfering with mouse events
                        //   transform: "translate(-50%,-100%)",
                        whiteSpace: "nowrap"
                    }}
                >
                    <p style={{ margin: 0, fontWeight: "bold" }}>
                        Top 3 Traits:
                            <div style={{color: hoveredData.color}}>
                                {hoveredData.skill_data.map((skill, s_index) => (
                                    s_index < 3 && (
                                        <span key={`skill${s_index}`}>{skill.skill_name}<br/></span>
                                    )
                                ))}
                            </div>
                    </p>
                </div>
            );
        }catch(error){
            return null
        }
    };
    //Polygon Modification
    const CustomRadarPolygon = ({ cx, cy, outerRadius, data }) => {
        try{
            const angleSlice = (2 * Math.PI) / data.length;
            // Generate points for the polygon
            const points = data.map((entry, index) => {
                const angle = index * angleSlice - Math.PI / 2;
                const locX = cx + (outerRadius * (entry.score_perc / 100)) * Math.cos(angle);
                const locY = cy + (outerRadius * (entry.score_perc / 100)) * Math.sin(angle);
                return {
                    ...entry,
                    x: locX,
                    y: locY,
                    labelX: cx + (outerRadius + 20) * Math.cos(angle), // Label position slightly outside
                    labelY: cy + (outerRadius + 20) * Math.sin(angle),
                    tooltipX: locX,
                    tooltipY: locY,
                    score_perc: entry.score_perc,
                    position: index
                };
            });
            return (
                <g>
                {points.map((point, index) => {
                    const nextPoint = points[(index + 1) % points.length];

                    return (
                        <React.Fragment key={index}>
                    <polygon
                        points={`${cx},${cy} ${point.x},${point.y} ${nextPoint.x},${nextPoint.y}`}
                        // fill={colors[index]}
                        fill={point.color}
                        stroke="black"
                        strokeWidth="0.5"
                        opacity="0.5"
                        onMouseEnter={(e) =>
                            setHoveredData({ ...point, x: e.pageX + 10, y: e.pageY - 20 })
                        }
                        onMouseLeave={() => setHoveredData(null)}
                    />
                    <text
                        x={point.position === 2 ? point.x+15 : point.x}
                        // y={point.y < 180 ? point.y-5 : (point.y > 190 ? point.y+12 : point.y)}
                        y={point.position > 1 && point.position < 7 ? point.y+15 : point.y -8}
                        textAnchor="middle"
                        fontSize={14}
                        fontWeight="bold"
                        fill={point.color}
                        // fill={colors[index]}
                    >
                    {point.score_perc}
                    </text>
                    </React.Fragment>
                    );
                })}
                </g>
            );
        }catch(e){
            console.log(e)
        }
    };
    const CustomPolarTick = (tick_props) => {
        try{
            
            const { payload, x, y } = tick_props;
            const lines = payload.value.split(' '); // Split label text by space
        
            return (
            <text className="chart-label" x={x} y={tick_props.index !== 4 ? y-30 : y} textAnchor={"middle"} fill={traitTypes[Object.keys(traitTypes)[tick_props.index]].color}>
                {/* //fill={colors[tick_props.index]} */}
                {/* textAnchor={"middle"} dominantBaseline="middle" textAnchor={textAnchor} fill="#666"*/}
                {lines.map((line, index) => (
                <tspan
                    key={index}
                    x={(tick_props.index === 2)
                        ? x+28
                            :tick_props.index === 6
                                ? x-32
                            : tick_props.index > 0 && tick_props.index < 4 
                            ? x+50
                            : (tick_props.index > 4 && tick_props.index < 8
                                ? x-52 : x)}
                    dy={index + 12}>
                    {line}
                </tspan>
                ))}
            </text>
            );
        }catch(error){
            
        }
    };
    //Get Percentage or Scores
    const getPerformPerc = (data) => {
        try{
            if(data.prev_score === 0
                && data.current_score === 0
            ){
                return 'NA';
            }else if(data.prev_score === 0
                && data.current_score > 0
            ){
                return (
                    <p className="text-green fw-bold mb-0">+{data.current_score}</p>
                );
            }else if(data.prev_score > 0
                && data.current_score === 0
            ){
                return 'NA';
            }else if(data.prev_score > 0
                && data.current_score > 0
            ){
                const perc = ((data.current_score-data.prev_score)/data.prev_score)*100;
                if(perc > 0){
                    return (
                        <p className="text-green fw-bold mb-0">{Math.round(perc)}%</p>
                    );
                }else{
                    return (
                        <p className="text-danger fw-bold mb-0">{Math.round(perc)}%</p>
                    );
                }
            }
            return 0;
        }catch(error){
            return '';
        }
    }

    return (
        <>
            <div className="row justify-content-center team-detail m-1">
                {/* Show Loader */}
                {pageLoading 
                    ?
                        <div className="text-center mt-5 mb-5">
                                <LoaderMedium size={45} />
                        </div>
                    :
                        <>
                            <div className="row">
                                {!isDataAvailable && (
                                    <div className="alert alert-danger">
                                        <p>No Endorsement Yet? Your Personality Map Awaits!<br/>
                                        Unlock it by earning endorsements.
                                        </p>
                                        <p className="mb-0">Two ways to start:</p>
                                        <ul>
                                            <li>Follow and endorse your friends—they’ll likely return the favor!</li>
                                            <li>Send a request to your friends to rate your strengths.</li>
                                        </ul>
                                        <p>The more you engage, the brighter your map shines.<br/>
                                        Start building your standout profile now!"</p>
                                    </div>
                                )}
                                {masterTraitData.length > 0 && (
                                <>
                               <div className="col-xl-12 col-md-12 col-12 col-sm-12 mb-3">
                                    <div className="card">
                                        <div className="m-4">
                                            <h3>Personality Map:</h3>
                                            <div className="d-flex justify-content-center chart-insight"> 
                                            {/* <div style={{ width: '100%', height: '100%' }}> */}
                                                {/* <ResponsiveContainer> */}
                                                <ResponsiveContainer
                                                    width={"100%"}
                                                    height={winWidth > 1199
                                                                ? 369
                                                                : winWidth < 576 
                                                                    ? 265
                                                                    : 350}>
                                                <RadarChart
                                                    cx={winWidth > 1199
                                                        ? winWidth/6
                                                        : winWidth < 576 
                                                            ? winWidth/4+35
                                                            : winWidth/4+100}
                                                    cy={winWidth > 1199
                                                        ? 369/2-20
                                                        :  winWidth < 576 
                                                            ? 265/2-10
                                                            : 350/2}
                                                    outerRadius={winWidth > 1199
                                                                ? (8/100)*winWidth
                                                                : winWidth < 576
                                                                    ? (17/100)*winWidth
                                                                    : (12/100)*winWidth}
                                                    data={masterTraitData}>
                                                {/* <RadarChart cx={350} cy={350} outerRadius={120} data={masterTraitData}> */}
                                                    <PolarGrid   />
                                                    <PolarAngleAxis dataKey="trait_type" tick={<CustomPolarTick />}/>
                                                    {/* <PolarRadiusAxis domain={[0, 100]} /> */}
                                                    <PolarRadiusAxis domain={[0, 100]} angle={70}/>
                                                    {/* <Tooltip content={<CustomTooltip />}/> */}
                                                    {/* <>
                                                    <CustomRadarPolygon cx={centerX} cy={centerY} outerRadius={outerRadius} data={data} />
                                                    </> */}
                                                    <Customized
                                                        component={<CustomRadarPolygon
                                                            cx={winWidth > 1199 
                                                                ? winWidth/6
                                                                : winWidth < 576
                                                                    ? winWidth/4+35
                                                                    : winWidth/4+100}
                                                            cy={winWidth > 1199
                                                                ? 369/2-20
                                                                :  winWidth < 576
                                                                    ? 265/2-10
                                                                    : 350/2}
                                                            outerRadius={winWidth > 1199
                                                                            ? (8/100)*winWidth
                                                                            : winWidth < 576
                                                                                ? (17/100)*winWidth
                                                                                : (12/100)*winWidth}
                                                            data={masterTraitData}
                                                            setHoveredData={setHoveredData}/>}  />
                                                    {/* <Radar name="Mike" dataKey="A" stroke="none" fill="none" fillOpacity={0.6} dot={{ fill: 'red', r: 5 }}/> */}
                                                </RadarChart>
                                                </ResponsiveContainer>
                                                <CustomTooltip hoveredData={hoveredData} />
                                                {/* <RadarChart height={500} width={500} 
                                                    outerRadius="80%" data={data}>
                                                    <PolarGrid />
                                                    <PolarAngleAxis dataKey="name" />
                                                    <PolarRadiusAxis />
                                                    <Radar dataKey="x" stroke="green"
                                                        fill="green" fillOpacity={0.5} />
                                                </RadarChart> */}
                                                {/* </div> */}
                                            </div>
                                        </div>
                                    </div>
                               </div>
                               <div className="col-xl-12 col-md-12 col-12 col-sm-12 pb-3">
                                <div className="card">
                                    <div className="m-4">
                                        <h3>Current Performance Vs. Previous Month:</h3>
                                        {/* {performanceData.length > 0
                                            ? */}
                                                <div className="table-responsive">
                                                <table className="table table-light mt-3">
                                                    <tbody>
                                                        {masterTraitData.map((perform, perform_indx) => (
                                                            <tr key={`trait_${perform_indx}`}>
                                                                <td style={{color: perform.color}}>{perform.trait_type}</td>
                                                                <td>{getPerformPerc(perform)}</td>
                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                </table>
                                                </div>
                                            {/* :
                                                <p className="mt-4">No Data Available</p>
                                        } */}
                                    </div>
                                </div>
                                </div>
                                </>
                                )}
                            </div>
                        </>
                }
            </div>
        </>
    )    
}

export default PortInsight;